<!--
 * @描述: 全部活动列表
 * @作者: Phil.Yu
 * @时间: 2021年04月08日
-->
<template>
  <div class="list" id="content">
    <div  v-if="list&&list.length">
      <div class="items" v-for="item in list" :key="item.activityId">
        <div>
          <div class="item">
            <div >
                <ActivityCard
                  :item="item"
                  :shareId="shareId"
                ></ActivityCard>
              </div>
          </div>
        </div>
      </div>
    </div>
      <div v-for="(item, index) in list" :key="index">
        <van-divider v-if="index>0" custom-style="padding:0 16px;background:#fff;margin:0;"/>
        <div class="item" >
            <div
              class="flex-center"
              @click="
                link(`/module/detail?id=${item.activityId}`, item.activityStatus)
              "
            >
              <van-image
                style="margin-right: 12px;"
                fit="cover"
                width="136"
                height="80"
                lazy-load
                :src="item.bannerUrl"
              />
              <div>
                <div class="title van-multi-ellipsis--l2">
                  {{ item.activityName }}
                </div>
                <div class="subtitle">
                  <div>
                    {{ item.startTime }} 至
                    {{ item.endTime }}
                  </div>
                  <div style="font-size: 11px;">
                    {{ item.activityType === 'OFFLINE' ? '同城活动' : '福利活动' }}
                    <span
                      style=" margin-left: 12px; font-weight: 500;"
                      :style="{ color: colorMap[item.activityStatusName] }"
                      >{{ item.activityStatusName }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex-center"
              style="margin-top: 8px; justify-content: space-between;"
            >
              <div
                class="flex-center"
                style="font-size: 13px; line-height: 22px; color: #969799;"
              >
                <image
                  style="width: 16px; height: 16px;"
                  src="../static/list-a.svg"
                  @click="
                    link(
                      `/module/detail?id=${item.activityId}`,
                      item.activityStatus
                    )
                  "
                />
                已有 {{ item.enter }} 人报名参加
                <div
                  class="flex-center"
                  style="margin-left: 10px;"
                  @click="showNoPass(item)"
                  v-if="item.activityStatus === 'UN_PASS'"
                >
                  <div
                  class="flex-center"
                  style="margin-left: 10px;"
                  @click="showNoPass(item)"
                >
                  <van-icon name="chat-o" size="20" dot />
                </div>
              </div>
            </div>
        </div>
      </div>
    </div> -->
    <div v-if="!list.length && !isLoading" class="error-text">
      <img
        src="https://img.esenyun.com/images/20200910/8ae5966d55c841acae6f27b52bff5ed1.png"
        style="width: 230px; height: 180px"
      />
      <div style="margin-top: 24px">暂无活动</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import env from "@/config/env";
import moment from "moment";
import ActivityCard from "./components/ActivityCard";
// import { mapState } from 'vuex'
export default {
  components: {
    ActivityCard,
  },
  data() {
    return {
      active: 0,
      isSHow: false,
      moment: moment,
      isLoading: false,
      error: false,
      colorMap: {
        审核中: "#EB5757",
        未通过: "#EB5757",
        审核失败: "#EB5757",
        进行中: "#52C41A",
        已结束: "#FAAD14",
        未开始: "#2F80ED",
      },
      sortVal: {
        id: 0,
        name: "全部",
      },
      sort: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: "UNDER_WAY",
          name: "进行中",
        },
        {
          id: "NO_BEGIN",
          name: "未开始",
        },
        {
          id: "END",
          name: "已结束",
        },
      ],
      current: {},
      nopassText: [],
      showTip: false,
      list: [],
      loading: false,
      finished: false,
      page: 0,
      shareId:""
    };
  },
  mounted() {
    this.page = 0;
    this.finished = false;
    this.shareId=Vue.ss.get('shareId')
    this.getList();
  },
  onPullDownRefresh() {
    this.page = 0;
    this.finished = false;
    this.getList();
    // uni.stopPullDownRefresh()
  },
  onReachBottom() {
    this.getList();
  },
  methods: {
    showNoPass(item) {
      this.showTip = true;
      this.current = item;
      if (item.verifyList && item.verifyList.length) {
        this.nopassText = item.verifyList;
      }
    },
    sleep(t) {
      return new Promise((s) => {
        setTimeout(() => {
          s();
        }, t * 1000);
      });
    },
    getAccount() {
      this.$http
        .get(`aocampaignsales/openapi/user/info/${env.agentId}`)
        .then((res) => {
          this.profile = res.data;
        });
    },
    getList() {
      if (this.finished) return;
      if (this.isLoading) return;
      if (!this.list) {
        this.list = [];
      }
      this.isLoading = true;
      let url = `aocampaigncallingcard/openapi/customer/callingcard/recommendActivity/${this.shareId}`;
      if (this.sortVal.id !== 0) {
        url = url + `&activityStatus=${this.sortVal.id}`;
      }
      this.$http
        .get(url)
        .then((res) => {
          if(res.data){
            this.isSHow = true;
            this.isLoading = false;
            res.data.forEach((item) => {
              item.startTime = moment(item.startTime).format("YYYY-MM-DD HH:mm");
              item.endTime = moment(item.endTime).format("YYYY-MM-DD HH:mm");
            });
            if (this.list.length) {
              this.list.push(...res.data);
            } else {
              this.list = res.data;
            }
            if (this.page === 0) {
              this.list = res.data;
            }
            this.page++;
            if (res.data.totalElements&&res.data.totalElements === this.list.length) {
              this.finished = true;
            }
          }else{
            this.isLoading = false;
            this.error = true;
            this.list = null;
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.error = true;
          this.list = null;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.navPosition {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 100;
}
.flow {
  text-align: left;
  word-break: keep-all;
  word-wrap: break-word;
}
.nopass {
  text-align: center;
  font-size: 18px;
  margin-top: 41px;
}
.banner {
  background: url("https://img.esenyun.com/images/20200302/2be97d11937a4744afa45eb23290fe2f.png")
    no-repeat;
  background-size: 100%;
}
.error-text {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #7d7e80;
  font-size: 14px;
  padding: 64px 0 32px 0;
}
.list {
  padding: 16px;
  .p-btn {
    width: 48px;
    height: 48px;
    position: fixed;
    right: 12px;
    bottom: 96px;
    background: #1f7dde;
    justify-content: center;
    border-radius: 50%;
    color: #fff;
    box-shadow: 0px 10px 12px rgba(31, 125, 222, 0.16);
    font-weight: 500;
    font-size: 13px;
    line-height: 14px;
    flex-direction: column;
  }
  .p-btn2 {
    .p-btn;
    background: #fff;
    color: #2f80ed;
    bottom: 32px;
    line-height: 16px;
  }
  /deep/.van-popup {
    border-radius: 8px;
  }
  .sort {
    height: 24px;
    margin-top: 8px;
    padding: 0 16px;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    justify-content: space-between;
  }
  .profile {
    width: calc(100% - 32px);
    position: absolute;
    bottom: -20px;
    margin: 0 16px;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
    padding: 16px 20px;
    display: flex;
    align-items: center;
    .avatar {
      width: 64px;
      height: 64px;
      border-radius: 50%;
    }
  }
  .items {
    margin-bottom: 12px;
    .item {
      background: #fff;
      padding: 16px;
      border-radius: 4px;
      // margin-bottom: 8px;
      /deep/.van-image__img {
        border-radius: 5px;
      }
      .title {
        width: 195px;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        padding-right: 10rpx;
        color: #000;
      }
      .subtitle {
        font-size: 10px;
        line-height: 20px;
        color: #4a4a4a;
      }
    }
  }
}
</style>
